import { render, staticRenderFns } from "./PhoneLikeConfirmation.vue?vue&type=template&id=72e74f42&"
import script from "./PhoneLikeConfirmation.vue?vue&type=script&lang=ts&"
export * from "./PhoneLikeConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneLikeConfirmation.vue?vue&type=style&index=0&id=72e74f42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
